import React from 'react';
import { motion } from 'framer-motion';
import CreateForm from '@/components/v1/Notes/CreateForm';

export default function CreateNote() {
  return (
    <div className="bg-gray-900 min-h-screen w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Create Note
          </h1>
          <CreateForm />
        </motion.div>
      </div>
    </div>
  );
}
